<template>
  <v-layout row wrap justify-center>
    <v-container row wrap fluid>
      <v-layout row wrap pb-0 fluid style="text-aligne: justify;">
        <v-flex hidden-sm-and-down>
          <v-spacer></v-spacer>
        </v-flex>
        <v-btn v-if="$route.params.idAssociazione" @click="$router.push('/anagrafica/associazioni')" class="btnDefault" small color="green darken-2" dark>
          <v-icon small left color="white">people</v-icon>Torna alle Associazioni
        </v-btn>
        <v-btn v-else @click="$router.push('/anagrafica/associazioni')" class="btnDefault" small color="green darken-2" dark>
          <v-icon small left color="white">people</v-icon>Vai alle Associazioni
        </v-btn>
        <v-btn
          v-if="checkFunzione(elencoFunzioni.INSERIMENTO_ASSOCIATO) || (checkFunzione(elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE) && isAdmin)"
          @click.prevent="newDialog(true)"
          class="btnDefault"
          small
          ml-0
          mr-0
          color="green darken-2"
          dark
        >
          <v-icon small>add</v-icon>Nuovo dati minimi
        </v-btn>
        <v-btn
          v-if="checkFunzione(elencoFunzioni.INSERIMENTO_ASSOCIATO) || (checkFunzione(elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE) && isAdmin)"
          @click.prevent="newDialog(false)"
          class="btnDefault"
          small
          ml-0
          mr-0
          color="green darken-2"
          dark
        >
          <v-icon small>add</v-icon>Nuovo
        </v-btn>
        <associato-filtri></associato-filtri>
        <v-btn
          slot="activator"
          v-if="$route.params.idAssociazione && isResponsabileAssociazione($route.params.idAssociazione) && !isMobile"
          @click="dialogGtWebOpen()"
          class="btnDefault"
          small
          color="accent white--text"
          dark
        >
          <v-icon small class="hidden-sm-and-down mr-1">import_export</v-icon>Esporta Iscritti
        </v-btn>
        <v-btn slot="activator" v-if="isAdmin || isResponsabileRuolo" @click="dialogSagittaOpen()" class="btnDefault" small color="accent white--text" dark>
          <v-icon small>import_export</v-icon>Esporta SAGITTA
        </v-btn>
        <v-btn @click="loadAssociati()" class="btnDefault" small color="primary white--text"> <v-icon small left color="white">cached</v-icon>Aggiorna </v-btn>
        <v-btn
          slot="activator"
          v-if="$route.params.idAssociazione && selected.length && checkFunzione(elencoFunzioni.STAMPA_CSAIN_PASS)"
          @click="dialogOpen()"
          class="btnDefault"
          small
          color="green white--text"
          dark
        >
          <v-icon small>print</v-icon>
          {{ !isMobile ? 'Stampa Pass selezionati' : 'Stampa Pass' }}
        </v-btn>
        <v-btn
          v-if="$route.params.idAssociazione && selected.length && checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIATO)"
          @click="eliminaAssociati()"
          class="text-xs-center; btnDefault"
          small
          color="red white--text"
        >
          <v-icon small>delete</v-icon>Elimina selezionati
        </v-btn>
      </v-layout>
    </v-container>
    <v-container fluid pt-0>
      <v-layout v-if="$route.params.idAssociazione" row class="text-xs-center">
        <v-flex xs12 mt-2>
          <h4 class="primary--text">
            <strong>{{ dettagliAssociazione.Denominazione }}</strong>
            <br />
            <v-chip v-if="dettagliAssociazione.Sezione" small color="secondary">{{ dettagliAssociazione.Sezione.Descrizione }}</v-chip>
          </h4>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-4 mb-3">
        <v-icon left class="hidden-sm-and-down mr-3">search</v-icon>
        <v-flex xs12 md2 mt-2 class="px-1">
          <v-text-field v-model="filtraTessere" box label="Numero Pass" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex v-if="!$route.params.idAssociazione" xs12 mt-2 md2 class="px-1">
          <v-autocomplete
            v-model="filtraSezioni"
            :items="associatiFiltrati"
            :return-object="false"
            item-text="SezioneDescrizione"
            item-value="SezioneDescrizione"
            box
            label="Regione"
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md2 mt-2 class="px-1">
          <v-text-field v-model="filtraTesto" box label="Cerca" clearable hide-details></v-text-field>
        </v-flex>

        <v-flex md3 xs12 mt-2 class="pt pl-3 text-xs-center">
          <v-btn-toggle v-model="filtraStato" :class="isMobile ? 'v-btn-toggle-vert' : 'v-btn-toggle-horiz'" flat mandatory>
            <v-btn flat value="Tutti" color="black">Tutti</v-btn>
            <v-btn flat value="Inseriti" color="orange">Inseriti</v-btn>
            <v-btn flat value="Iscritti" color="green">Iscritti</v-btn>
            <v-btn flat value="Presidenti" color="purple">Presidenti</v-btn>
            <v-btn flat value="Tecnici" color="blue">Tecnici</v-btn>
            <v-btn flat value="Istruttori" color="black">Istruttori</v-btn>
            <v-btn flat value="Open" color="cyan">Open</v-btn>
            <v-btn v-if="isAdmin" flat value="Non_Attivi" color="red">NON Attivi</v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="associatiFiltrati"
          :search="filtraTesto"
          :pagination.sync="pagination"
          :custom-sort="customSort"
          :select-all="$route.params.idAssociazione && checkFunzione(elencoFunzioni.STAMPA_CSAIN_PASS)"
          :hide-headers="isMobile"
          :class="{ mobile: isMobile }"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <tr v-if="!isMobile" :active="props.selected" @click="selectRow(props)">
              <td v-if="$route.params.idAssociazione && checkFunzione(elencoFunzioni.STAMPA_CSAIN_PASS)" :class="{ 'red lighten-5': !props.item.isAttivo }">
                <v-checkbox v-if="props.item.isAttivo" v-model="props.selected" @click="props.selected = !props.selected" hide-details></v-checkbox>
                <v-icon v-if="!props.item.isAttivo" color="red darken-3">remove_circle</v-icon>
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-right">{{ props.item.NumeroTessera }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-right">{{ props.item.TesseraCsain }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable font-weight-bold">{{ props.item.Denominazione }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable">{{ props.item.Associazione }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable">{{ props.item.SezioneDescrizione}}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-right">
                {{ showDataAssociato(props.item) || props.item.id === userData.id ? props.item.Email : '-' }}
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-right">
                {{ showDataAssociato(props.item) || props.item.id === userData.id ? props.item.Telefono : '-' }}
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">
                {{ showDataAssociato(props.item) || props.item.id === userData.id ? props.item.CittaIndirizzo : '-' }}
              </td>

              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-center">
                <v-tooltip v-if="props.item.StatoIscrizione" top>
                  <v-avatar
                    slot="activator"
                    :size="15"
                    :class="{
                      red: props.item.StatoIscrizione.toLowerCase() != 'inserito' && props.item.StatoIscrizione.toLowerCase() != 'iscritto',
                      green: props.item.StatoIscrizione.toLowerCase() == 'iscritto',
                      orange: props.item.StatoIscrizione.toLowerCase() == 'inserito',
                    }"
                  ></v-avatar>
                  <span>{{ props.item.StatoIscrizione }}</span>
                </v-tooltip>
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-center">
                <v-avatar v-if="props.item.Tecnico" size="24" color="blue" small>
                  <span class="white--text xm">T</span>
                </v-avatar>
                <v-avatar v-if="props.item.Istruttore" size="24" color="red" small>
                  <span class="white--text xm">I</span>
                </v-avatar>
                <v-avatar v-if="props.item.Open && !props.item.RichiestoPassGare" size="24" color="cyan" small>
                  <span class="white--text xm">O</span>
                </v-avatar>
                <v-avatar v-if="props.item.Open && props.item.RichiestoPassGare" size="24" color="green" small>
                  <span class="white--text xm">O</span>
                </v-avatar>
                <v-avatar v-if="props.item.Quadro && props.item.RuoloQuadro == 'PRESIDENTE'" size="24" color="purple" small>
                  <span class="white--text xm">P</span>
                </v-avatar>
              </td>

              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="text-xs-center">
                <v-tooltip v-if="canModifyAssociato(props.item.id, props.item.associazioneId)" top>
                  <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="ma-1 mr-0" color="primary">
                    <v-icon small color="primary">edit</v-icon>
                  </v-btn>
                  <span>Modifica Tesserato</span>
                </v-tooltip>
                <v-tooltip v-if="$route.params.idAssociazione && checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIATO)" top>
                  <v-btn slot="activator" v-if="props.item.isAttivo" @click="eliminaSelezionato(props.item)" small outline icon class="ma-1" color="red">
                    <v-icon small color="red">delete</v-icon>
                  </v-btn>
                  <span>Elimina Tesserato</span>
                </v-tooltip>
                <v-tooltip
                  v-if="!canModifyAssociato(props.item.id, props.item.associazioneId) && checkFunzione(elencoFunzioni.VISUALIZZAZIONE_ASSOCIATO) && showDataAssociato(props.item)"
                  top
                >
                  <v-btn slot="activator" @click="viewItem(props.item)" small outline icon class="ma-1 mr-0" color="purple">
                    <v-icon small color="purple">visibility</v-icon>
                  </v-btn>
                  <span>Visualizza Scheda</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-btn slot="activator" :disabled="disableAttestati(props.item)" @click="openAttestato(props.item)" small outline icon class="mr-0" color="green">
                    <v-icon small color="green">fa-graduation-cap</v-icon>
                  </v-btn>
                  <span>Visualizza Attestati</span>
                </v-tooltip>
              </td>
            </tr>

            <tr v-else :active="props.selected" @click="props.selected = !props.selected" style="padding-bottom: 35px;">
              <td class="flex-td">
                <ul class="flex-content">
                  <li v-if="$route.params.idAssociazione && checkFunzione(elencoFunzioni.STAMPA_CSAIN_PASS)" data-label="Sel" class="flex-item">
                    <v-checkbox v-if="props.item.isAttivo" v-model="props.selected" hide-details></v-checkbox>
                    <v-icon v-if="!props.item.isAttivo" color="red darken-3">remove_circle</v-icon>
                  </li>
                  <li data-label="Pass" class="flex-item">{{ props.item.NumeroTessera }}</li>
                  <li data-label="Csain" class="flex-item">{{ props.item.TesseraCsain }}</li>
                  <li data-label="Denominazione" bold class="flex-item">{{ props.item.Denominazione }}</li>
                  <li data-label="Sodalizio" bold class="flex-item">{{ props.item.Denominazione }}</li>
                  <li data-label="Regione" bold class="flex-item">{{ props.item.SezioneDescrizione }}</li>
                  <li data-label="Città" class="flex-item">{{ showDataAssociato(props.item) || props.item.id === userData.id ? props.item.CittaIndirizzo : '-' }}</li>
                  <li data-label="Email" class="flex-item">{{ showDataAssociato(props.item) || props.item.id === userData.id ? props.item.Email : '-' }}</li>
                  <li data-label="Telefono" class="flex-item">{{ showDataAssociato(props.item) || props.item.id === userData.id ? props.item.Telefono : '-' }}</li>

                  <li data-label="Stato" class="flex-item">
                    <v-tooltip v-if="props.item.StatoIscrizione" top>
                      <v-avatar
                        slot="activator"
                        :size="15"
                        :class="{
                          red: props.item.StatoIscrizione.toLowerCase() != 'inserito' && props.item.StatoIscrizione.toLowerCase() != 'iscritto',
                          green: props.item.StatoIscrizione.toLowerCase() == 'iscritto',
                          orange: props.item.StatoIscrizione.toLowerCase() == 'inserito',
                        }"
                      ></v-avatar>
                      <span>{{ props.item.StatoIscrizione }}</span>
                    </v-tooltip>
                  </li>
                  <li :class="!props.item.isAttivo" data-label="Tipo" class="flex-item">
                    <v-avatar v-if="props.item.Tecnico" size="24" color="blue" small>
                      <span class="white--text xm">T</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Istruttore" size="24" color="red" small>
                      <span class="white--text xm">I</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Open && !props.item.RichiestoPassGare" size="24" color="cyan" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Open && props.item.RichiestoPassGare" size="24" color="green" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Quadro && props.item.RuoloQuadro == 'PRESIDENTE'" size="24" color="purple" small>
                      <span class="white--text xm">P</span>
                    </v-avatar>
                  </li>

                  <li data-label="Azioni" class="flex-row">
                    <v-tooltip v-if="canModifyAssociato(props.item.id, props.item.associazioneId)" top>
                      <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="ma-1 mr-0" color="primary">
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                      <span>Modifica Tesserato</span>
                    </v-tooltip>

                    <v-tooltip v-if="$route.params.idAssociazione && checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIATO)" top>
                      <v-btn slot="activator" v-if="props.item.isAttivo" @click="eliminaSelezionato(props.item)" small outline icon class="ma-1" color="red">
                        <v-icon small color="red">delete</v-icon>
                      </v-btn>
                      <span>Elimina Tesserato</span>
                    </v-tooltip>
                    <v-tooltip
                      v-if="
                        !canModifyAssociato(props.item.id, props.item.associazioneId) && checkFunzione(elencoFunzioni.VISUALIZZAZIONE_ASSOCIATO) && showDataAssociato(props.item)
                      "
                      top
                    >
                      <v-btn slot="activator" @click="viewItem(props.item)" small outline icon class="ma-1 mr-0" color="purple">
                        <v-icon small color="purple">visibility</v-icon>
                      </v-btn>
                      <span>Visualizza Scheda</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <v-btn slot="activator" :disabled="disableAttestati(props.item)" @click="openAttestato(props.item)" small outline icon class="mr-0" color="green">
                        <v-icon small color="green">fa-graduation-cap</v-icon>
                      </v-btn>
                      <span>Visualizza Attestati</span>
                    </v-tooltip>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
          <template slot="no-results">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <!-- PAGINAZIONE IN TABELLA  -->
          <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
        </v-data-table>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialogEliminato" persistent max-width="700">
      <span>Elimina tesserato</span>
      <v-card>
        <v-card-title class="display-1 font-weight-bold red white--text">Elimina tesserato</v-card-title>
        <v-card-text class="headline">{{ eliminatoSelected ? "Verrà eliminato l'associato selezionato" : 'Verranno eliminati gli associati selezionati' }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogEliminato = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="elimnaAssociatiSodalizio($route.params.idAssociazione)" color="red white--text" dark> <v-icon small class="mr-1">delete</v-icon>Elimina tesserato </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAttestato" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Scarica Attestato</v-card-title>
        <v-card-text class="headline">Scaricare l'attestato?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAttestato = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="downloadAttestato()" color="accent white--text" dark> <v-icon small class="mr-1">print</v-icon>Download Attestato </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" xs-6 persistent max-width="490">
      <v-card>
        <v-card-title class="display-1 font-weight-bold green white--text">Stampa dei pass gara</v-card-title>
        <v-card-text class="headline">Verranno stampati solo i pass degli arcieri che possono partecipare alle gare</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="stampaCsainPass($route.params.idAssociazione, selected)" color="green white--text" dark> <v-icon small class="mr-1">print</v-icon>Genera PDF </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSagitta" persistent max-width="620">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Esportazione Associati</v-card-title>
        <v-card-text class="headline">Verranno esportati i dati nel formato compatibile con SAGITTA</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogSagitta = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="exportAssociatiSagitta(0)" v-if="isAdmin || isResponsabileRuolo" color="accent white--text" dark> <v-icon small left>import_export</v-icon>Esporta SAGITTA parz. </v-btn>
          <v-btn @click="exportAssociatiSagitta(1)" v-if="isAdmin" color="accent white--text" dark> <v-icon small left>import_export</v-icon>Esporta SAGITTA comp.</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGtWeb" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Esportazione Iscritti</v-card-title>
        <v-card-text class="headline">Esportazione Iscritti in formato excel</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogGtWeb = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="exportAssociazioni($route.params.idAssociazione, 'GTWEB')" color="accent white--text" dark>
            <v-icon small left>import_export</v-icon>Esporta Inseriti per GTWEB
          </v-btn>

          <v-btn @click="exportAssociazioni($route.params.idAssociazione, 'ALL')" color="accent white--text" dark> <v-icon small left>import_export</v-icon>Esporta Tutti </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAttestatoList" max-width="1300">
      <v-card tile>
        <v-layout justify-center>
          <v-flex style="text-align: center;" xs12>
            <attestato-form :id-associato.sync="idSelezionato" :nome.sync="nomeAssociato"></attestato-form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <associato-form
      :prop-elm-anagrafica.sync="associatoObj"
      :prop-image.sync="imageObj"
      :prop-form-mode.sync="formMode"
      :prop-dati-minimi.sync="isDatiMini"
      :is-storico="false"
      @reset-elm="resetElm()"
    ></associato-form>
  </v-layout>
</template>

<script>
  import AssociatoForm from './AssociatoForm';
  import AttestatoForm from './AttestatoForm';
  import AssociatoFiltri from './AssociatoFiltri';
  import AssociatoEntity from './AssociatoEntity';
  import ImageEntity from '../generale/ImageEntity';
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { callbackify } from 'util';

  export default {
    components: {
      AssociatoForm,
      AssociatoFiltri,
      AttestatoForm,
    },
    data() {
      return {
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        formMode: Util.enFormMode.VISUALIZZAZIONE,
        dialog: false,
        dialogGtWeb: false,
        dialogSagitta: false,
        dialogAttestato: false,
        dialogEliminato: false,
        isDatiMini: false,
        ruoli: Security.ruolo,
        filtraTesto: '',
        isMobile: false,
        visibile: false,
        dialogAttestatoList: false,
        filtraTessere: '',
        filtraSezioni: '',
        filtraStato: 'Tutti',
        attestatoSelected: null,
        nomeAssociato: null,
        idSelezionato: null,
        eliminatoSelected: null,
        selected: [],
        headers: [
          { text: 'Pass', sortable: true, value: 'NumeroTessera', width: '80px', align: 'right' },
          { text: 'Csain', sortable: true, value: 'TesseraCsain', width: '80px', align: 'right' },
          { text: 'Denominazione', sortable: true, value: 'Denominazione' },
          { text: 'Sodalizio', sortable: true, value: 'Associazione' },
          { text: 'Regione', sortable: true, value: 'SezioneDescrizione' },
          { text: 'Email', sortable: true, value: 'Email', align: 'right' },
          { text: 'Telefono', sortable: true, value: 'Telefono', align: 'right' },
          {
            text: 'Città',
            sortable: true,
            value: 'CittaIndirizzo',
          },
          { text: 'Stato', sortable: true, value: 'StatoIscrizione', width: '70px', align: 'center' },
          { text: 'Tipo', sortable: false, value: '', width: '100px', align: 'center' },
          { text: 'Azioni', sortable: false, value: '', width: '140px', align: 'center' },
        ],
        pagination: {
          rowsPerPage: 10,
        },
        associatoObj: new AssociatoEntity(),
        imageObj: new ImageEntity(),
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('associatiModule', ['getAssociati', 'getAssociato', 'getDettagliAssociazione', 'getImage']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters('sharedModule', ['getSezioni']),
      ...mapGetters(['userData']),

      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },
      image() {
        return this.getImage;
      },
      sezioni() {
        return this.getSezioni;
      },
      associati() {
        return this.getAssociati;
      },
      associato() {
        return this.getAssociato;
      },
      dettagliAssociazione() {
        return this.getDettagliAssociazione;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },
      isResponsabile(id) {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE && this.userData.associazioneId == id;
        } else {
          return false;
        }
      },

      isResponsabileRuolo() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE;
        } else {
          return false;
        }
      },

      associatiFiltrati() {
        // filtro in tempo reale
        let associatiList = null;
        if (this.$route.params.idAssociazione) {
          associatiList = this.associati.filter((a) => a.associazioneId == this.$route.params.idAssociazione);
        } else {
          if (this.userData.AssociazioneId) {
            associatiList = this.associati.filter((a) => a.associazioneId == this.userData.AssociazioneId);
          } else {
            associatiList = this.associati;
          }
        }

        return associatiList.filter((i) => {
          if (!this.filtraSezioni && !this.filtraTessere && this.filtraStato == 'Tutti') {
            return true;
          } else if (this.filtraStato != 'Tutti' && !this.filtraTessere && !this.filtraSezioni) {
            switch (this.filtraStato) {
              case 'Inseriti':
                return i.StatoIscrizione == 'Inserito';
              case 'Iscritti':
                return i.Open == 0 && i.StatoIscrizione == 'Iscritto';
              case 'Attivi':
                return i.isAttivo == 1 && i.StatoIscrizione != 'Cancellato';
              case 'Non_Attivi':
                return i.isAttivo == 0;
              case 'Tecnici':
                return i.Open == 0 && i.Tecnico == 1;
              case 'Presidenti':
                return i.Open == 0 && i.Quadro == 1 && i.RuoloQuadro == 'PRESIDENTE' && i.StatoIscrizione != 'Cancellato';
              case 'Istruttori':
                return i.Istruttore == 1 && i.StatoIscrizione != 'Cancellato';
              case 'Open':
                return i.Open == 1 && i.isAttivo == 1 && i.StatoIscrizione != 'Cancellato';
              default:
                break;
            }
          }
          if (this.filtraTessere != '' && i.NumeroTessera && this.filtraStato == 'Tutti') {
            return i.NumeroTessera == this.filtraTessere;
          }
          if (this.filtraSezioni != '' && i.SezioneDescrizione && this.filtraStato == 'Tutti') {
            return i.SezioneDescrizione == this.filtraSezioni;
          } else {
            if (i.NumeroTessera && !this.filtraSezioni) {
              switch (this.filtraStato) {
                case 'Inseriti':
                  return i.NumeroTessera == this.filtraTessere && i.StatoIscrizione == 'Inserito';
                case 'Iscritti':
                  return i.Open == 1 && i.NumeroTessera == this.filtraTessere && i.StatoIscrizione == 'Iscritto';
                case 'Attivi':
                  return i.NumeroTessera == this.filtraTessere && i.isAttivo == 1 && i.StatoIscrizione != 'Cancellato';
                case 'Non_Attivi':
                  return i.NumeroTessera == this.filtraTessere && i.isAttivo == 0;
                case 'Presidenti':
                  return i.NumeroTessera == this.filtraTessere && i.Open == 0 && i.Quadro == 1 && i.RuoloQuadro == 'PRESIDENTE' && i.StatoIscrizione != 'Cancellato';
                case 'Tecnici':
                  return i.Open == 0 && i.NumeroTessera == this.filtraTessere && i.Tecnico == 1 && i.StatoIscrizione != 'Cancellato';
                case 'Istruttori':
                  return i.NumeroTessera == this.filtraTessere && i.Istruttore == 1 && i.StatoIscrizione != 'Cancellato';
                case 'Open':
                  return i.Open == 1 && i.NumeroTessera == this.filtraTessere && i.StatoIscrizione != 'Cancellato';
                default:
                  break;
              }
            }
            if (i.SezioneDescrizione && !this.filtraTessere) {
              switch (this.filtraStato) {
                case 'Inseriti':
                  return i.SezioneDescrizione == this.filtraSezioni && i.StatoIscrizione == 'Inserito';
                case 'Iscritti':
                  return i.SezioneDescrizione == this.filtraSezioni && i.StatoIscrizione == 'Iscritto';
                case 'Attivi':
                  return i.SezioneDescrizione == this.filtraSezioni && i.isAttivo == 1 && i.StatoIscrizione != 'Cancellato';
                case 'Non_Attivi':
                  return i.SezioneDescrizione == this.filtraSezioni && i.isAttivo == 0;
                case 'Presidenti':
                  return i.SezioneDescrizione == this.filtraSezioni && i.Open == 0 && i.Quadro == 1 && i.RuoloQuadro == 'PRESIDENTE' && i.StatoIscrizione != 'Cancellato';
                case 'Tecnici':
                  return i.SezioneDescrizione == this.filtraSezioni && i.Tecnico == 1 && i.StatoIscrizione != 'Cancellato';
                case 'Istruttori':
                  return i.SezioneDescrizione == this.filtraSezioni && i.Istruttore == 1 && i.StatoIscrizione != 'Cancellato';
                case 'Open':
                  return i.Open == 1 && i.SezioneDescrizione == this.filtraSezioni && i.Istruttore == 1 && i.StatoIscrizione != 'Cancellato';
                default:
                  break;
              }
            }
          }
          return false;
        });
      },
    },
    watch: {
      associato() {
        this.associatoObj = new AssociatoEntity(this.associato);
      },
      image() {
        this.imageObj = new ImageEntity(this.image);
      },

      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.pagination.rowsPerPage = 10;
            this.isMobile = true;
            break;
          case 'md':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 20;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 25;
            this.isMobile = false;
            break;
        }
      },
    },

    created() {
      const vm = this;

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
          this.isMobile = false;
          break;
        case 'lg':
          this.isMobile = false;
          break;
        case 'xl':
          this.isMobile = false;
          break;
      }

      // se value == false instanzia un'entity vuota e visualizza la modale
      bus.$on('associatoDialog', function (value) {
        vm.associatoDialog = value;
        if (!value) {
          vm.isDatiMini = false
          vm.associatoObj = new AssociatoEntity();
          vm.associatoObj.Associazione = vm.dettagliAssociazione;
          vm.imageObj = new ImageEntity();
        }
      });

      bus.$on('deleteAssociati', function (value) {
        if (value) {
          setTimeout(function () {
            vm.loadAssociati();
          }, 1000);
        }
      });
      bus.$on('chiusura', function (value) {
        if (value) {
          vm.dialogAttestatoList = false;
        }
      });
      vm.loadTipologie();
      vm.loadAssociati();
      //  vm.pagination.rowsPerPage = this.calculatedRow;
      if (this.$route.params.idAssociazione) {
        vm.loadDettagliAssociazione(this.$route.params.idAssociazione);
      } else if (this.userData.AssociazioneId) {
        vm.loadDettagliAssociazione(this.userData.AssociazioneId);
      }
    },
    methods: {
      ...mapActions('associatiModule', [
        'loadAssociati',
        'loadAssociatoAsync',
        'loadAssociato',
        'loadDettagliAssociazione',
        'loadImage',
        'deleteAssociato',
        'deleteAssociatoAsync',
        'deleteAssociati',
        'stampaPassAssociati',
        'stampaPassAssociatiAsync',
        'stampaAttestato',
        'stampaAttestatoAsync',
        'exportSagittaXLS',
        'loadAttestati',
      ]),
      ...mapActions('associazioniModule', ['exportIscrittiGTWEBXLS', 'exportIscrittiAssociazioneXLS']),
      ...mapActions('sharedModule', ['loadTipologie']),

      editItem(item) {
        const vm = this;
        this.loadAssociatoAsync(item.id).then(() => {
          this.loadImage(item.id).then(() => {
            vm.formMode = vm.checkFormMode(false);
            bus.$emit('associatoDialog', true);
          });
        });
      },

      disableAttestati(item) {
        let retVal = true;
        if (item.Attestato) {
          if ((this.userData.Role && this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO) || this.userData.Role === this.ruoli.ADMIN) {
            retVal = false;
          } else {
            if (this.userData.Role === this.ruoli.ASSOCIATO && item.id == this.userData.id) {
              retVal = false;
            }
            if (this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE && this.userData.AssociazioneId == item.associazioneId) {
              retVal = false;
            }
          }
        }

        return retVal;
      },

      openAttestato(item) {
        if (item) {
          this.dialogAttestatoList = true;
          this.idSelezionato = item.id;
          this.nomeAssociato = item.Denominazione;
          bus.$emit('idSelezionato', this.idSelezionato);
        }
      },

      dialogGtWebOpen() {
        const vm = this;
        vm.dialogGtWeb = true;
      },

      dialogSagittaOpen() {
        const vm = this;
        vm.dialogSagitta = true;
      },

      dialogOpen() {
        const vm = this;
        vm.dialog = true;
      },

      selectRow(props) {
        const vm = this;
        if (this.$route.params.idAssociazione && vm.checkFunzione(vm.elencoFunzioni.STAMPA_CSAIN_PASS)) {
          props.selected = !props.selected;
        }
      },
      viewItem(item) {
        const vm = this;
        this.loadAssociatoAsync(item.id).then(() => {
          this.loadImage(item.id).then(() => {
            vm.formMode = vm.formModes.VISUALIZZAZIONE;
            bus.$emit('associatoDialog', true);
          });
        });
      },
      newDialog(t) {
        this.isDatiMini = t
        this.formMode = this.formModes.INSERIMENTO;
        bus.$emit('associatoDialog', true);
      },

      stampaCsainPass(idAssociazione, items) {
        const idSelected = [];
        items.forEach((element) => {
          if (!element.Open) {
            idSelected.push(element.id);
          }
        });
        if (idSelected.length > 0) {
          this.stampaPassAssociatiAsync({ id: idAssociazione, data: idSelected });
        }
        this.selected = [];
        this.dialog = false;
      },

      printAttestato(item) {
        const vm = this;
        vm.attestatoSelected = item;
        vm.dialogAttestato = true;
      },
      /* funzione richiamata dal pulsante di eliminazione dalla lista */
      eliminaSelezionato(item) {
        const vm = this;
        vm.eliminatoSelected = item;
        vm.dialogEliminato = true;
      },

      /* funziona richiamata dal tasto elimina della toolbar */
      eliminaAssociati() {
        const vm = this;
        vm.eliminatoSelected = null;
        vm.dialogEliminato = true;
      },

      /* funziona richiamata dal tasto elimina del dialog */
      elimnaAssociatiSodalizio(idAssociazione) {
        /* se provengo dal tasto sulla lista */
        if (this.eliminatoSelected) {
          this.deleteAssociatoAsync(this.eliminatoSelected);
          this.eliminatoSelected = null;
        } else {
          /* se provengo dal'elimina sulla toolbar */
          const associatiId = [];
          this.selected.forEach((i) => {
            associatiId.push(i.id);
          });
          if (associatiId.length > 0) {
            const item = {
              associazioneId: idAssociazione,
              associatiId: associatiId,
            };
            this.deleteAssociati(item);
            this.selected = [];
          }
          this.eliminatoSelected = null;
        }
        this.dialogEliminato = false;
      },

      downloadAttestato() {
        const vm = this;
        if (vm.attestatoSelected) {
          vm.stampaAttestatoAsync(vm.attestatoSelected.id);
        }
        vm.dialogAttestato = false;
      },

      exportAssociazioni(idAssociazione, tipo) {
        const vm = this;
        if (tipo == 'GTWEB') {
          vm.exportIscrittiGTWEBXLS(idAssociazione);
        }
        if (tipo == 'ALL') {
          vm.exportIscrittiAssociazioneXLS(idAssociazione);
        }

        vm.dialogGtWeb = false;
      },

      exportAssociatiSagitta(p) {
        const vm = this;
        vm.exportSagittaXLS(p);
        vm.dialogSagitta = false;
      },

      resetElm() {
        this.associatoObj = new AssociatoEntity();
        this.associatoObj.Associazione = this.dettagliAssociazione;
        this.imageObj = new ImageEntity();
        this.formMode = this.formModes.VISUALIZZAZIONE;
      },
      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      checkFormMode(insertMode) {
        if (insertMode && Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO, this.userData.Role)) {
          return this.formModes.INSERIMENTO;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO, this.userData.Role)) {
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role)) {
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_ASSOCIATO, this.userData.Role)) {
          return this.formModes.VISUALIZZAZIONE;
        }
      },
      isResponsabileAssociazione(idAssociazione) {
        let retVal = false;
        if (this.userData.AssociazioneId && idAssociazione) {
          retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
        }
        return retVal;
      },

      showDataAssociato(item) {
        if (this.userData.Role === this.ruoli.ASSOCIATO) {
          return item.canViewData;
        } else {
          return true;
        }
      },

      canModifyAssociato(idAssociato, idAssociazione) {
        let retVal = false;
        if (idAssociato) {
          if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId && idAssociazione) {
            retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      canInsertAssociato(idAssociazione) {
        let retVal = false;
        if (this.formMode == this.formModes.INSERIMENTO) {
          if (Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId) {
            retVal = Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      customSort(items, index, isDescending) {
        const compare = new Intl.Collator('it').compare;
        if (index === null) return items;

        return items.sort((a, b) => {
          let sortA = a[index];
          let sortB = b[index];

          if (index == 'Denominazione') {
            sortA = a.Denominazione;
            sortB = b.Denominazione;
          } else if (index == 'SezioneDescrizione') {
            sortA = a.SezioneDescrizione;
            sortB = b.SezioneDescrizione;
          } else if (index == 'IndirizzoCorrispondenza.CittaIndirizzo') {
            sortA = a.IndirizzoCorrispondenza.CittaIndirizzo;
            sortB = b.IndirizzoCorrispondenza.CittaIndirizzo;
          }

          if (isDescending) {
            [sortA, sortB] = [sortB, sortA];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          [sortA, sortB] = [sortA, sortB].map((s) => {
            return (s || '').toString();
          });

          return compare(sortA, sortB);
        });
      },
    },
  };
</script>
